export enum OnboardingStatus {
  WAITING_SUBMIT_FROM_EMPLOYEE = 'WAITING_SUBMIT_FROM_EMPLOYEE',
  WAITING_CORRECTION_FROM_EMPLOYEE = 'WAITING_CORRECTION_FROM_EMPLOYEE',
  NOT_SENT = 'NOT_SENT',
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  VALIDATED = 'VALIDATED',
  CANCELED = 'CANCELED'
}

export enum ContractStatus {
  ACTIVE = 'ACTIVE',
  FUTURE = 'FUTURE'
}

export interface OnboardingAssignee {
  employeeNumber: string;
  fullName: string;
}

export interface NewHireContract {
  contractId: number;
  firstName: string;
  lastName: string;
  hiredBy: string;
  status: OnboardingStatus;
  formSentBy: string;
  formSentToEmail: string;
  formSentDate: string;
  contractBeginDate: string;
  daysWithSameStatus: number;
  employeeId: number;
  cliRegId: number;
  employeeNumber: string;
  contractNumber: string;
  contractStatus: ContractStatus;
  assignee: OnboardingAssignee;
  candidates: OnboardingAssignee[];
  cancellable?: boolean;
  processInstanceId?: string;
  processDefinitionName?: string;
}

export interface ChartsItemDTO {
  key: OnboardingStatus;
  count: number;
}

export interface ChartStatsDTO {
  total: number;
  items: ChartsItemDTO[];
}

export interface ContractStatusByOnboardingStatusDTO {
  onboardingStatus: OnboardingStatus;
  active: number;
  future: number;
}

export interface ContractDistributionStatsDTO {
  total: number;
  items: ContractStatusByOnboardingStatusDTO[];
}

export interface OnboardingChartsStatsDTO {
  upcomingEmployeesStats: ChartStatsDTO;
  onboardingDistributionStats: ChartStatsDTO;
  contractDistributionStats: ContractDistributionStatsDTO;
}

